import React, {
  createRef,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import ct from "class-types.macro";

type Category = {
  name: string;
  count: number;
  link: string;
};

interface Props {
  categories: Category[];
  categoriesTotal: number;
  shouldCollapseCategories: boolean;
}

export default function FoodServiceResourcesCategories({
  categories,
  categoriesTotal,
  shouldCollapseCategories,
}: Props): JSX.Element {
  const viewMoreRef = useRef<HTMLButtonElement>(null);
  const [categoryRefs, setCategoryRefs] = useState<RefObject<HTMLLIElement>[]>(
    [],
  );

  useEffect(() => {
    setCategoryRefs(categories?.map(() => createRef<HTMLLIElement>()));
  }, [categories]);

  const handleViewMore = () => {
    if (categoryRefs?.length > 0 && viewMoreRef.current) {
      categoryRefs.forEach((ref) => {
        ref.current?.classList.remove("fsr-hide");
      });

      viewMoreRef.current.classList.add("fsr-hide");
    }
  };

  return (
    <>
      {!!categories?.length && (
        <div data-module="foodServiceResourcesCategories">
          <ul className="fsr-nav">
            <li className="fsr-label fsr-mobile">
              Topics <span className="resource-count">{categoriesTotal}</span>
            </li>
            {categories?.map(({ name, count, link }: Category, index) => (
              <li
                className={`fsr-link ${
                  index >= 10 && shouldCollapseCategories ? "fsr-hide" : ""
                }`}
                key={name}
                ref={categoryRefs[index]}
              >
                <a href={link}>
                  {name} <span className="resource-count">{count}</span>
                </a>
              </li>
            ))}
            {shouldCollapseCategories && categories?.length > 10 && (
              <button
                type="button"
                className={`${ct(
                  "bg-transparent",
                  "border-none",
                )} fsr-link fsr-view-more`}
                onClick={handleViewMore}
                ref={viewMoreRef}
              >
                See More <i className="icon-breadcrumb" />
              </button>
            )}
          </ul>
        </div>
      )}
    </>
  );
}
